export enum InfoElementType {
  DEFAULT = "DEFAULT",
  SUCCESS = "SUCCESSFULLY_UPDATED",
  WAITING = "SENT_TO_OIK",
  ERROR = "ERROR",
}
